import { NotificationManager } from 'react-notifications';
import { AppSetting  } from '../common/functions';
import { GetPrefixUniversity } from '../MainApp';
let instance = null;
class UserData {
    AppSetting = AppSetting();
    constructor() {
        this.getUserDetails();
    }

    getUserDetails() {
        if(this.AppSetting){
            let is_anonymous = window.localStorage.getItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "anonymous");
            this.GivenName = window.localStorage.getItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "GivenName");
            this.USER_NAME = window.localStorage.getItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "USER_NAME");
            this.UnixEpoch = window.localStorage.getItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "UnixEpoch");
            this.emailid = window.localStorage.getItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "emailid");
            this.role = window.localStorage.getItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "role");
            this.token = window.localStorage.getItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "token");
            this.timeZone = window.localStorage.getItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "timeZone");
            this.isAnonymous = is_anonymous && is_anonymous === 'true' ? true : false;
            this.isLTIStudent = window.localStorage.getItem("isLTIStudent") === 'true' ? JSON.parse(window.localStorage.getItem("isLTIStudent")) : false
        }else {
            setTimeout(() => {
                this.getUserDetails();
              }, 5000)
        }
        
    }

    setUserDetails(userData) {
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "GivenName", userData.GivenName);
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "USER_NAME", userData.USER_NAME);
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "UnixEpoch", userData.UnixEpoch);
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "emailid", userData.emailid);
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "role", userData.role);
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "token", userData.authtoken);
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "timeZone", userData.timeZone);
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "anonymous", userData.isAnonymous);
    }

    hasValidData() {
        if (this.USER_NAME !== "" && this.USER_NAME !== undefined && this.USER_NAME !== null
            && this.token !== undefined && this.token !== null && this.token !== "")
            return true;
        return false;
    }

    clearSessionData() {
        // window.localStorage.clear();
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'token', '');
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'GivenName', '');
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'USER_NAME', '');
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'UnixEpoch', '');
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'emailid', '');
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'OSUID', '');
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'role', '');
        window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + 'anonymous', '');
        window.localStorage.setItem('isLTIStudent', '');

        this.emailid = null;
        this.GivenName = null;
        this.role = null;
        this.token = null;
        this.UnixEpoch = null;
        this.USER_NAME = null;
        this.timeZone = null;
    }
}

class UISettings {
    AppSetting = AppSetting();
    constructor() {
        this.refreshUISettings();
    }
    refreshUISettings() {
        this.fontSize = window.localStorage.getItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "fontSize");
    }

    setFontSize(fontSize) {
        let htmlElement = document.getElementsByTagName('html')[0];
        htmlElement.style.fontSize = fontSize;
        this.fontSize = window.localStorage.setItem(this.AppSetting.REACT_APP_UNIVERSITY_SUFFIX + "_" + "fontSize", fontSize);
    }

    applyUIStyles() {
        let htmlElement = document.getElementsByTagName('html')[0];
        htmlElement.style.fontSize = this.fontSize;
    }

}
export default class Properties {
    universityPrefix = GetPrefixUniversity();
    constructor() {
        if (window.localStorage.getItem(`${this.universityPrefix}_StudentAppsettings`) !== null) {
            const AppSetting = JSON.parse(window.localStorage.getItem(`${this.universityPrefix}_StudentAppsettings`));
            this.baseURL = AppSetting.REACT_APP_APIURL.trim();
            this.enableLogin = JSON.parse(AppSetting.REACT_APP_ENABLE_LOGIN);
            this.appURL = AppSetting.REACT_APP_URL;
            this.baseName = AppSetting.REACT_APP_BASENAME.trim();
            this.currentUserData = new UserData();
            this.settings = new UISettings();
            this.loginType = AppSetting.REACT_APP_LOGIN_TYPE ? AppSetting.REACT_APP_LOGIN_TYPE.trim() : 'shiboleth';
            this.mailDomain = AppSetting.REACT_APP_MAIL_DOMAIN ? AppSetting.REACT_APP_MAIL_DOMAIN.trim() : 'osu.edu';
            this.enableLTI = AppSetting.REACT_APP_ENABLE_LTI ? JSON.parse(AppSetting.REACT_APP_ENABLE_LTI) : (window?.localStorage?.getItem("isLTIStudent") !== null ? window.localStorage.getItem("isLTIStudent") === 'true' : false);
            this.schoolMode = AppSetting.REACT_APP_SCHOOL_MODE ? JSON.parse(AppSetting.REACT_APP_SCHOOL_MODE) : false;
            this.currentQuizURL = "";
            this.eqmMode = AppSetting.REACT_APP_EQM_MODE ? JSON.parse(AppSetting.REACT_APP_EQM_MODE) : false;
            this.notRegister = AppSetting.REACT_APP_NOT_REGISTER ? JSON.parse(AppSetting.REACT_APP_NOT_REGISTER) : false;
            this.universityFullName = AppSetting?.univFullName;
            this.universitySuffix = AppSetting.REACT_APP_UNIVERSITY_SUFFIX ? AppSetting.REACT_APP_UNIVERSITY_SUFFIX.trim() : null;
            this.isHybrid = AppSetting.REACT_APP_IS_HYBRID ? JSON.parse(AppSetting.REACT_APP_IS_HYBRID) : false;
            this.isLTIStudent = window.localStorage.getItem("isLTIStudent") ? JSON.parse(window.localStorage.getItem("isLTIStudent")) : false
        } else {
            // let _appSetting = new AppSettings();
            // this.currentUserData = new UserData();
            // this.settings = new UISettings();
            NotificationManager.error("App Setting Not Found", "ERROR!", 5000);
        }
    }

    getUISettings() {
        return this.settings;
    }
}